import config from '../constants/config';
import { objectToSearchParams } from './toSearchParams';

// Role 4 = Agency, Role 5 = Automation (see legacy-shop-schema.ts UserinfoData.role)
const AGENCY_ROLE = 4;
const AUTOMATION_ROLE = 5;

export interface NewCustomerFormUserInfo {
  role?: number | null;
  firstname?: string | null;
  lastname?: string | null;
  surname?: string | null;
  company?: string | null;
  email?: string | null;
  phone?: string | null;
}

export const isAgencyOrAutomationRole = (role: number | null | undefined): boolean =>
  role === AGENCY_ROLE || role === AUTOMATION_ROLE;

export const buildNewCustomerFormUrl = (
  userInfo: NewCustomerFormUserInfo | null | undefined,
  gepardNr: string | null | undefined,
  locale: string,
): string | null => {
  const domain = config.newCustomerFormDomain;

  if (!domain || !userInfo || !isAgencyOrAutomationRole(userInfo.role)) {
    return null;
  }

  const params = objectToSearchParams(
    {
      Name: userInfo.lastname || userInfo.surname,
      Vorname: userInfo.firstname,
      Gepard: gepardNr,
      Agenturname: userInfo.company,
      'E-Mail': userInfo.email,
      Telefon_1: userInfo.phone,
    },
    true,
  );

  const queryString = params.toString();

  return `${domain}/${locale}/neukundenformular${queryString ? `?${queryString}` : ''}`;
};
